import BasicRepository from "./basicRepository";
import { LifecycleResource } from "../resources";
import Client from "../client";
import { ProjectResource } from "client/resources/projectResource";

class LifecycleRepository extends BasicRepository<LifecycleResource, LifecycleResource> {
    constructor(client: Client) {
        super("Lifecycles", client);
    }
    preview(lifecycle: LifecycleResource): Promise<LifecycleResource> {
        return this.client.get(lifecycle.Links["Preview"]);
    }
    projects(lifecycle: LifecycleResource) {
        return this.client.get<ProjectResource[]>(lifecycle.Links["Projects"]);
    }
}

export default LifecycleRepository;
